/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddVoucherResponseApiFrom } from '../../models/add-voucher-response-api-from';

export interface ApiV3ServiceAddVoucherGet$Params {

/**
 * *	language code
 */
  lang?: string;

/**
 * *	coupon number
 */
  cpnNo?: string;
}

export function apiV3ServiceAddVoucherGet(http: HttpClient, rootUrl: string, params?: ApiV3ServiceAddVoucherGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AddVoucherResponseApiFrom>> {
  const rb = new RequestBuilder(rootUrl, apiV3ServiceAddVoucherGet.PATH, 'get');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.query('cpnNo', params.cpnNo, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AddVoucherResponseApiFrom>;
    })
  );
}

apiV3ServiceAddVoucherGet.PATH = '/api/v3/service/AddVoucher';
